import { createContext, useState } from 'react'
export const PlanValidationContext = createContext()


function PlanValidation({ children }) {

    const [planValidationData, setPlanValidationData] = useState({
        exchangeContact: true,
        addToWallet: true,
        whatsappExchangeContact: true
    });

    return (
        <PlanValidationContext.Provider value={[planValidationData, setPlanValidationData]}>
            {children}
        </PlanValidationContext.Provider>
    )
}

export default PlanValidation;